import { type ProductSortingSchema, productSortingSchema } from '@coas/validators/const';
import { atom } from 'jotai';

const getInitialValue = (): ProductSortingSchema => {
    if (typeof window === 'undefined') return null;

    const sorting = sessionStorage.getItem('coas-product-sorting');

    return productSortingSchema.parse(JSON.parse(sorting ?? 'null'));
};

const baseAtom = atom<ProductSortingSchema>(getInitialValue());

export const sortingStateAtom = atom<
    ProductSortingSchema,
    [ProductSortingSchema] | [(prev: ProductSortingSchema) => ProductSortingSchema],
    ProductSortingSchema
>(
    get => get(baseAtom),
    (get, set, update) => {
        const nextValue = typeof update === 'function' ? update(get(baseAtom)) : update;
        set(baseAtom, productSortingSchema.parse(nextValue));
        sessionStorage.setItem('coas-product-sorting', JSON.stringify(nextValue));

        return nextValue;
    },
);
